import React from 'react'

import { AIGeneratedGradientBright } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

const TRIAL_CTA_CLASS = 'ai-sub-landing__cta ai-sub-landing__cta--gradient'
const TRIAL_CTA_CONTENT = (
  <>
    <AIGeneratedGradientBright className="ai-sub-landing__cta-icon" width="20" height="20" aria-hidden="true" />
    <span className="ai-sub-landing__cta-label">Try Free Generations</span>
  </>
)

// Signed-out visitors must sign in before the trial can be granted, so onTryFreeGenerations fires
// the sign-in handler (a real button for keyboard/AT correctness); signed-in eligible users have no
// handler and navigate straight to the studio.
function TrialCta({ studioHref, onTryFreeGenerations = null }) {
  if (onTryFreeGenerations) {
    return (
      <button type="button" className={TRIAL_CTA_CLASS} onClick={onTryFreeGenerations}>
        {TRIAL_CTA_CONTENT}
      </button>
    )
  }

  return <a className={TRIAL_CTA_CLASS} href={studioHref}>{TRIAL_CTA_CONTENT}</a>
}

TrialCta.propTypes = {
  studioHref: string.isRequired,
  onTryFreeGenerations: func,
}

export default TrialCta
